import {ActivatedRouteSnapshot, Routes} from '@angular/router';
import {
  AccountStatementItemListReslover,
  AccountStatementsReslover,
  CategoriesResolver,
  CategoryResolver,
  CompetitorResultListResolver,
  CopyEventResolver,
  CopyRaceResolver,
  createEventCalendarResolver,
  createLeagueCalendarResolver,
  CurrentUserDetailsResolver,
  DiscountsDetailsResolver,
  eventCalendarCodebookResolver,
  EventCategoryResolver,
  eventCodebookResolver,
  EventCommercialItemsPriceResolver,
  EventDetailsHolderPublicResolver,
  EventDetailsPublicResolver,
  EventDetailsResolver,
  EventListResolver,
  EventPaymentSettingsResolver,
  EventRegistrationsResolver,
  generateCodebookResolvers,
  PublicLeagueDetailsResolver,
  PublicLeagueInitResolver,
  LeagueResolver,
  LeaguesResolver,
  ListOfDiscountsResolver,
  LiveEventResolver,
  LiveEventsResolver,
  LiveRaceResolver,
  LiveResultsResolver,
  MeasurementEventDetailsResolver,
  MeasurementsWaypointListResolver,
  MeasurementsWaypointResolver,
  MeasurersListReslover,
  MessageResolver,
  MyTraceyInitResolver,
  NewEventsResolver,
  organiserCodebookResolver,
  OrganiserPaymentDataResolver,
  OrganizersListReslover,
  OrganizersRequestListResolver,
  RaceAdditionalPricingItemsPriceResolver,
  RaceAdditionalPricingItemsResolver,
  EventAdditionalPricingItemsResolver,
  raceCodebookResolver,
  RaceCommercialItemsPriceResolver,
  RaceCommercialItemsResolver,
  RaceCompetitorsPrivateResolver,
  RaceCompetitorsPublicResolver,
  RaceDetailsPublicResolver,
  RaceItemDetailsResolver,
  RaceRouteResolver,
  registerToRaceCodebookResolver,
  RegisterToRaceResolver,
  UpcomingEventsResolver,
  UserFavoritesResolver,
  UserRecommendedResolver,
  UserListResolver,
  userProfileCodebookResolver,
  UserResolver,
  UserResultsResolver,
  UserRoleResolver,
  UserUpcomingResolver,
  WaypointListResolver,
  WsPayStatusResolver,
  UserStatisticResolver,
  MyEntryDetailsResolver,
  UserRegistrationsResolver,
  MyOrderDetailsResolver,
  AdministratorDetailsResolver,
  AdministratorsResolver,
  LeagueCompetitorsResolver,
  LeagueDuplicateCompetitorsCandidateResolver,
  LeagueCompetitorsCountriesResolver,
  LeagueCompetitorsCategoryItemsResolver,
  LeagueEventsResolver,
  PublicLeagueEventsResolver,
  UserEventsSportsResolver,
  UserEventsCountriesResolver,
  LeagueResultsAvailableRacesResolver,
  LeagueStandingsMetaResolver,
  LeagueManagementInitResolver, LeagueManagementLeagueResolver, LeagueManagementEventsResolver
} from "@resolvers";
import {
  autoLoginOnLeaveGuard,
  canActivateAdminGuard,
  canActivateAuthenticationGuard,
  canActivateChildAdminGuard,
  Features,
  Permission
} from "@services";
import {
  AboutComponent,
  AccountStatementDetailsComponent,
  AdminEventDetailsComponent,
  AdminLeagueDetailsComponent,
  AdminRaceDetailsComponent,
  AdminTemplateComponent,
  CategoriesListComponent,
  ChangePasswordOnRecoveryComponent,
  ComplaintsAndDisputesComponent,
  ContactComponent,
  CookiePolicyComponent,
  DiscountsDetailsComponent,
  ErrorStateComponent,
  EventCalendarComponent,
  EventDetailsComponent,
  EventManagementComponent,
  EventMeasurementsManagementComponent,
  EventPreviewComponent,
  GeneralConditionsComponent,
  IntellectualPropertyComponent,
  LandingComponent,
  LeagueCalendarComponent,
  LeagueDetailsComponent,
  ListOfAccountStatementsComponent,
  OrganiserAdminDetailsComponent,
  ListOfAdministratorsComponent,
  ListOfDiscountsComponent,
  ListOfEventsComponent,
  ListOfLeaguesComponent,
  ListOfOrganisersComponent,
  RequestsPageComponent,
  ListOfUsersComponent,
  LiveResultsComponent,
  LiveResultsRaceDetailsComponent,
  LoginComponent,
  MessagesComponent,
  MyTraceyComponent,
  NoticeOnPersonalDataProtectionComponent,
  OrganiserDetailsComponent,
  OrganizerDashboardComponent,
  PaymentComponent,
  PoliciesComponent,
  RaceDetailsComponent,
  RaceManagementComponentComponent,
  RecoverLostPasswordComponent,
  RegisterToRaceComponent,
  SignupComponent,
  SignupVerificationComponent,
  TestComponent,
  UserDetailsComponent,
  UserProfileEditComponent,
  TimingComponent,
  MyTraceyTabs,
  MyTraceyUpcomingComponent,
  MyTraceyFavoritesComponent,
  MyTraceyResultsComponent,
  MyTraceyOverviewComponent,
  MyTraceyComponentState,
  MyEntryComponent,
  TimerComponent,
  ListOfRequestsComponent,
  ListOfRequestsType,
  LeagueTabs,
  LeagueInfoTabComponent,
  LeagueEventListTabComponent,
  LeagueResultsTabComponent,
  LeagueFeedsTabComponent,
  LeagueOverviewTabComponent,
  LeagueManagementComponent,
  MyEntryPersonalInfoComponent,
  MyEntryCompletePaymentComponent,
  MyTraceyOrderDetailsComponent,
  MyTraceyOrdersComponent,
  LeagueResultsManagementComponent,
  LeagueEventsComponent,
  LeagueCompetitorsComponent,
  LeagueRoundResultsComponent,
  LeagueOverallResultsComponent, LiveResultsPhotoPointComponent,
} from "@pages";
import {EventDetailsComponentType,
  EventItemType,
  LeagueDetailsComponentType,
  RaceDetailsComponentType} from "@model";
import {canActivateMyTraceyProfileGuard} from "./services/my-tracey-profile-completed.guard";


export const LANDING_ROUTE: string = "/landing";
export const EVENT_CALENDAR_ROUTE: string = "/eventCalendar";
export const PRIVATE_EVENT_CALENDAR_ROUTE: string = "/private/eventCalendar";
export const FINISHED_EVENTS_ROUTE: string = "/finishedEvents";
export const PRIVATE_FINISHED_EVENTS_ROUTE: string = "/private/finishedEvents";
export const SERIES_ROUTE: string = "/leagues";
export const SERIES_DETAILS: string = "details";
export const SERIES_OVERVIEW: string = "/leagues/details/overview";
export const SERIES_INFO: string = "/leagues/details/info";
export const SERIES_LEAGUE_EVENTS: string = "/leagues/details/events";
export const SERIES_STANDINGS: string = "/leagues/details/standings";
export const SERIES_FEEDS: string = "/leagues/details/feeds";
export const PRIVATE_SERIES_ROUTE: string = "/private/leagues";
export const LOGIN_ROUTE: string = "/login";
export const MY_TRACEY: string = "/private/myTracey";
export const MY_TRACEY_UPCOMING: string = "/private/myTracey/upcoming";
export const MY_TRACEY_FAVORITES: string = "/private/myTracey/favorites";
export const MY_TRACEY_RESULTS: string = "/private/myTracey/results";
export const MY_TRACEY_OVERVIEW: string = "/private/myTracey/overview";
export const MY_TRACEY_EDIT: string = "/private/myTracey/edit";
export const MY_TRACEY_ENTRY: string = "/private/myTracey/entry";
export const MY_ENTRY_PERSONAL_INFO: string = "/private/myTracey/entry/personalInfo";
export const MY_TRACEY_ORDERS: string = "/private/myTracey/orders";
export const ORDER_DETAILS: string = "/private/myTracey/order";
export const MY_ORDER_COMPLETE_PAYMENT: string = "payment";
export const SIGNUP_ROUTE: string = "/signup";
export const RECOVER_LOST_PASSWORD_ROUTE: string = "/recoverLostPassword";
export const REGISTER_TO_RACE: string = "registerToRace";

export const REDIRECT_TO_REGISTER_TO_RACE: string = "/private/eventCalendar/eventDetails/registerToRace";
export const RACE_DETAILS: string = "raceDetails";
export const EVENT_DETAILS: string = "eventDetails";
export const POLICIES: string = "/policies";
export const GENERAL_CONDITIONS_ROUTE : string = "/policies/general-conditions";
export const INTELLECTUAL_PROPERTY_ROUTE : string = "/policies/intellectual-property";
export const COOKIE_POLICY_ROUTE : string = "/policies/cookie-policy";
export const CONTACT_ROUTE: string = "/contact";
export const ABOUT_ROUTE: string = "/about";
export const COMPLAINTS_AND_DISPUTES: string = "/policies/complaints-and-disputes";
export const PERSONAL_DATA_PROTECTION: string = "/policies/personal-data-protection";
export const PAYMENT: string = "/payment";
export const LIVE_RESULTS: string = "/liveResults";
export const PRIVATE_LIVE_RESULTS: string = "/private/liveResults";
export const LIVE_RESULTS_RACE_DETAILS_FULL_SCREEN: string = "fullscreen/race";
export const LIVE_RESULTS_RACE_DETAILS: string = "race";
export const LIVE_RESULTS_PHOTO_POINT: string = `${LIVE_RESULTS}/photoPoint`;
export const PRIVATE_LIVE_RESULTS_PHOTO_POINT: string = `${PRIVATE_LIVE_RESULTS}/photoPoint`;

export const DETAILS: string = "details";
export const EDIT: string = "edit";
export const ADD: string = "add";
export const COPY: string = "copy";
export const MANAGEMENT: string = "management";
export const ORGANISER_LIST: string = "/private/admin/organisers";
export const MEASUREMENTS_LIST: string = "/private/admin/measurements";
export const ORGANISER_MEASUREMENTS_MANAGEMENT: string = "/private/admin/measurements/management";
export const ORGANISER_EDIT: string = "/private/admin/organisers/edit";
export const LIST_OF_REQUESTS: string = "/private/admin/requests/incoming";
export const ADMINISTRATOR_LIST: string = "/private/admin/administrators";
export const ADMINISTRATOR_DETAILS: string = "/private/admin/administrators/details";
export const ACCOUNT_STATEMENTS: string = "/private/admin/accountStatements";
export const USER_LIST: string = "/private/admin/users";
export const TIMING_SCREEN: string = "private/admin/timing";
export const TIMER_SCREEN: string = "private/admin/timer";
export const ORGANISER_EVENTS: string = "/private/admin/events";
export const LEAGUES: string = "/private/admin/leagues";
export const LEAGUES_EDIT: string = "/private/admin/leagues/edit";
export const LEAGUES_MANAGEMENT: string = "/private/admin/leagues/management";
export const LEAGUES_MANAGEMENT_EVENTS: string = "/private/admin/leagues/management/events";
export const LEAGUES_MANAGEMENT_COMPETITORS: string = "/private/admin/leagues/management/competitors";
export const LEAGUES_MANAGEMENT_RESULTS: string = "/private/admin/leagues/management/results";
export const LEAGUES_MANAGEMENT_RESULTS_BY_ROUND: string = "/private/admin/leagues/management/results/by-round";
export const LEAGUES_MANAGEMENT_RESULTS_OVERALL: string = "/private/admin/leagues/management/results/overall";
export const ORGANISER_EVENT_EDIT: string = "/private/admin/events/edit";
export const ORGANISER_EVENT_ADD: string = "/private/admin/events/add";
export const ORGANISER_EVENT_COPY: string = "/private/admin/events/copy";
export const ORGANISER_EVENT_PREVIEW: string = "/private/admin/preview"
export const ORGANISER_RACE_EDIT_COPY: string = "/private/admin/events/copy/race/edit";
export const ORGANISER_RACE_EDIT: string = "/private/admin/events/race/edit";
export const ORGANISER_RACE_COPY: string = "/private/admin/events/race/copy";
export const ORGANISER_RACE_MANAGEMENT: string = "/private/admin/events/race/management";
export const ORGANISER_RACE_ADD: string = "/private/admin/events/race/add";
export const ORGANISER_DASHBOARD: string = "/private/admin/dashboard";
export const INCOMING_REQUESTS: string = "/private/admin/requests/incoming";
export const OUTGOING_REQUESTS: string = "/private/admin/requests/outgoing";
export const ORGANISER_PROFILE: string = "/private/admin/profile";
export const ORGANISER_MESSAGES: string = "/private/admin/messages";
export const USER_MESSAGES: string = "/private/messages";
export const ORGANISER_EVENTS_MANAGEMENT: string = "/private/admin/events/management";

export const CATEGORIES_LIST: string = "/private/admin/categories";
export const LIST_OF_DISCOUNTS: string = "/private/admin/discounts";
export const DISCOUNT_DETAILS: string = "discountDetails";

/// Web server should be correctly configured to handle 404 with index.html and not with error for browser history
function eventDetailsItem(path: string, isMyTracey?: boolean) {
  return {
    path: path,
    component: EventDetailsComponent,
    resolve: {
      eventDetailsHolder: EventDetailsHolderPublicResolver,
      competitors: RaceCompetitorsPublicResolver,
      ...generateCodebookResolvers('countries', 'languages', 'currencies', 'genders')
    },
    data: {
      isMyTracey: isMyTracey ?? false
    }
  };
}

function finishedRaceDetailsItem(path: string) {
  return {
    path: path,
    component: RaceDetailsComponent,
    resolve: {
      eventDetails: EventDetailsPublicResolver,
      raceDetails: RaceDetailsPublicResolver,
      competitors: RaceCompetitorsPublicResolver,
      results: CompetitorResultListResolver,
      waypointList: WaypointListResolver,
      raceRoute: RaceRouteResolver,
      categories: CategoriesResolver,
      ...generateCodebookResolvers('languages', 'countries', 'genders')
    }
  };
}

function raceDetailsItem(path: string) {
  return {
    path: path,
    component: RaceDetailsComponent,
    resolve: {
      eventDetails: EventDetailsPublicResolver,
      raceDetails: RaceDetailsPublicResolver,
      raceCommercialItems: RaceCommercialItemsResolver,
      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
      competitors: RaceCompetitorsPublicResolver,
      results: CompetitorResultListResolver,
      waypointList: WaypointListResolver,
      raceRoute: RaceRouteResolver,
      categories: CategoriesResolver,
      ...generateCodebookResolvers('languages', 'countries', 'genders')
    },
  };
}

function registerToRaceItem(path: string, isPreviewComponent: boolean = false, isManagement: boolean = false) {
  return {
    path: path,
    component: RegisterToRaceComponent,
    data: {
      reuseComponent: false,
      isPreviewComponent: isPreviewComponent,
      isManagement: isManagement
    },
    runGuardsAndResolvers: ((from: ActivatedRouteSnapshot, to: ActivatedRouteSnapshot) => {
      return true;
    }),
    resolve: {
      raceCommercialItems: RaceCommercialItemsPriceResolver,
      eventCommercialItems: EventCommercialItemsPriceResolver,
      raceAdditionalItems: RaceAdditionalPricingItemsPriceResolver,
      eventItem: EventDetailsPublicResolver,
      currentUserDetails: CurrentUserDetailsResolver,
      race: RegisterToRaceResolver,
      ...generateCodebookResolvers('genders', 'sizes', 'transports', 'currencies', 'meals', 'countries', 'disciplines', 'languages'),
    },
  };
}


function commonMenuItems() {
  return [{
    path: 'eventCalendar',
    component: EventCalendarComponent,
    resolve: {
      ...eventCalendarCodebookResolver,
      listOfEvents: createEventCalendarResolver(EventItemType.UPCOMING),
    },
    data: {calendarType: EventItemType.UPCOMING}
  },
    {
      path: 'eventCalendar',
      children: [
        eventDetailsItem('eventDetails'),
        raceDetailsItem('raceDetails'),
        {
          path: 'eventDetails',
          children: [
            raceDetailsItem('raceDetails'),
            registerToRaceItem('registerToRace'),
            {
              path: 'raceDetails',
              children: [
                registerToRaceItem('registerToRace'),
              ]
            },
          ]
        },
        eventDetailsItem('eventDetails/:slug'),
        {
          path: 'eventDetails/:slug',
          children: [
            raceDetailsItem('raceDetails'),
            registerToRaceItem('registerToRace'),
            {
              path: 'raceDetails',
              children: [
                registerToRaceItem('registerToRace'),
              ]
            },
          ]
        },
      ]
    },
    {
      path: 'finishedEvents',
      component: EventCalendarComponent,
      resolve: {
        ...eventCalendarCodebookResolver,
        listOfEvents: createEventCalendarResolver(EventItemType.FINISHED)
      },
      data: {calendarType: EventItemType.FINISHED}
    },
    {
      path: 'finishedEvents',
      children: [
        eventDetailsItem('eventDetails'),
        {
          path: 'eventDetails',
          children: [
            finishedRaceDetailsItem('raceDetails')
          ]
        },
        eventDetailsItem('eventDetails/:slug'),
        {
          path: 'eventDetails/:slug',
          children: [
            finishedRaceDetailsItem('raceDetails')
          ]
        },
      ]
    },
    {
      path: 'leagues',
      children: [
        {
          path: '',
          component: LeagueCalendarComponent,
          resolve: {
            ...generateCodebookResolvers('leaguesCountries', 'leaguesSports', 'languages', 'leaguesStatuses', 'countries'),
            listOfLeagues: createLeagueCalendarResolver(),
          }
        },
        {
          path: 'details',
          component: LeagueDetailsComponent,
          resolve: {
            init: PublicLeagueInitResolver,
          },
          children: [
            {
              path: 'overview',
              component: LeagueOverviewTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                leagueEvents: PublicLeagueEventsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: { activeTab: LeagueTabs.OVERVIEW }
            },
            {
              path: 'info',
              component: LeagueInfoTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: { activeTab: LeagueTabs.INFO }
            },
            {
              path: 'events',
              component: LeagueEventListTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                leagueEvents: PublicLeagueEventsResolver,
                ...generateCodebookResolvers('countries', 'languages', 'sports'),
              },
              data: {activeTab: LeagueTabs.LEAGUE_EVENTS },
            },
            {
              path: 'standings',
              component: LeagueResultsTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                leagueEvents: PublicLeagueEventsResolver,
                standingsMeta: LeagueStandingsMetaResolver,
                categoryItems: LeagueCompetitorsCategoryItemsResolver,
                competitorsCountries: LeagueCompetitorsCountriesResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: {activeTab: LeagueTabs.STANDINGS}
            },
            {
              path: 'feeds',
              component: LeagueFeedsTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: {activeTab: LeagueTabs.FEEDS }
            },
          ]
        },
        {
          path: 'details/:slug',
          component: LeagueDetailsComponent,
          resolve: {
            init: PublicLeagueInitResolver,
          },
          children: [
            {
              path: 'overview',
              component: LeagueOverviewTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                leagueEvents: PublicLeagueEventsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: { activeTab: LeagueTabs.OVERVIEW }
            },
            {
              path: 'info',
              component: LeagueInfoTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: { activeTab: LeagueTabs.INFO }
            },
            {
              path: 'events',
              component: LeagueEventListTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                leagueEvents: PublicLeagueEventsResolver,
                ...generateCodebookResolvers('countries', 'languages', 'sports'),
              },
              data: {activeTab: LeagueTabs.LEAGUE_EVENTS },
            },
            {
              path: 'standings',
              component: LeagueResultsTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                standingsMeta: LeagueStandingsMetaResolver,
                leagueEvents: PublicLeagueEventsResolver,
                categoryItems: LeagueCompetitorsCategoryItemsResolver,
                competitorsCountries: LeagueCompetitorsCountriesResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: {activeTab: LeagueTabs.STANDINGS}
            },
            {
              path: 'feeds',
              component: LeagueFeedsTabComponent,
              resolve: {
                league: PublicLeagueDetailsResolver,
                ...generateCodebookResolvers('countries', 'languages')
              },
              data: {activeTab: LeagueTabs.FEEDS }
            },
          ]
        },
      ],
    },
  ];
}


function liveResults() {
  return [{
    path: 'liveResults', component: LiveResultsComponent, resolve: {
      liveEvents: LiveEventsResolver,
      ...generateCodebookResolvers('languages', 'countries'),
    }
  },
    {
      path: 'liveResults',
      children: [{
        path: 'race',
        component: LiveResultsRaceDetailsComponent,
        resolve: {
          race: LiveRaceResolver,
          event: LiveEventResolver,
          liveResult: LiveResultsResolver,
          categories: CategoriesResolver,
          ...generateCodebookResolvers('languages', 'countries', 'genders'),
        },
      },
        {
          path: 'fullscreen/race',
          component: LiveResultsRaceDetailsComponent,
          resolve: {
            race: LiveRaceResolver,
            event: LiveEventResolver,
            liveResult: LiveResultsResolver,
            categories: CategoriesResolver,
            ...generateCodebookResolvers('languages', 'countries', 'genders'),
          },
          data: {isFullScreen: true},
        },
        {
          path: 'photoPoint',
          component: LiveResultsPhotoPointComponent,
          resolve: {
            event: LiveEventResolver,
            ...generateCodebookResolvers('languages', 'countries'),
          },
        }
      ]
    }
  ];
}

/// path strategy to work correctly, we don't won't web server to handle missing links instead let Angular handle that.
const routes: Routes = [
  {path: '', redirectTo: '/landing', pathMatch: 'full'},
  {path: 'contact', component: ContactComponent},
  {path: 'about', component: AboutComponent},
  {
    path: 'policies',
    component: PoliciesComponent,
    children: [
      { path: 'general-conditions', component: GeneralConditionsComponent },
      { path: 'intellectual-property', component: IntellectualPropertyComponent },
      { path: 'cookie-policy', component: CookiePolicyComponent },
      { path: 'complaints-and-disputes', component: ComplaintsAndDisputesComponent },
      { path: 'personal-data-protection', component: NoticeOnPersonalDataProtectionComponent },
      { path: '', redirectTo: 'general-conditions', pathMatch: 'full' }
    ]
  },
  {path: 'auth/google/callback', loadComponent: () => import('./pages/public/google-callback/google-callback.component').then(m => m.GoogleCallbackComponent)},
  {path: 'login', component: LoginComponent},
  {
    path: 'signup', component: SignupComponent, resolve: {
      ...generateCodebookResolvers('genders')
    }
  },
  {path: 'signupVerification', component: SignupVerificationComponent},
  {path: 'recoverLostPassword', component: RecoverLostPasswordComponent},
  {path: 'changePasswordOnRecovery', component: ChangePasswordOnRecoveryComponent},
  {path: 'emptyState', component: ErrorStateComponent},
  {
    path: 'payment',
    component: RegisterToRaceComponent,
    canActivate: [canActivateAuthenticationGuard()],
    canDeactivate: [autoLoginOnLeaveGuard],
    resolve: {
      wspayConfirmation: WsPayStatusResolver,
      currentUserDetails: CurrentUserDetailsResolver,
      ...generateCodebookResolvers('currencies', 'languages')
    }
  },
  ...liveResults(),
  {
    path: 'private', children: [
      {
        path: 'admin', component: AdminTemplateComponent,
        resolve: {unreadMessages: MessageResolver},
        children: [
          {path: 'dashboard', component: OrganizerDashboardComponent},
          {
            path: 'timing',
            component: TimingComponent,
            resolve: {
              event: EventDetailsResolver,
              timingWaypointList: MeasurementsWaypointListResolver,
              ...generateCodebookResolvers('languages', 'countries')
            },
            data: {
              permission: Permission.Edit
            }
          },
          {
            path: 'timer',
            component: TimerComponent,
            resolve: {
              event: EventDetailsResolver,
              waypoint: MeasurementsWaypointResolver,
              ...generateCodebookResolvers('languages', 'countries')
            },
            data: {
              permission: Permission.Edit
            }
          },
          {
            path: 'categories',
            component: CategoriesListComponent,
            resolve: {
              categories: CategoryResolver,
              ...generateCodebookResolvers('categoryTypes')
            },
            data: {permission: Permission.Edit, feature: Features.Categories}
          },
          {
            path: 'discounts', component: ListOfDiscountsComponent,
            resolve: {listOfDiscounts: ListOfDiscountsResolver},
          },
          {
            path: 'discounts', children: [
              {
                path: 'discountDetails',
                component: DiscountsDetailsComponent,
                resolve: {discount: DiscountsDetailsResolver}
              },
            ]
          },
          {
            path: 'myTracey',
            component: OrganiserDetailsComponent,
            data: {feature: Features.OrganiserProfile, permission: Permission.Edit},
            resolve: {
              users: UserListResolver,
              paymentData: OrganiserPaymentDataResolver,
              ...organiserCodebookResolver
            }
          },
          {
            path: 'events', component: ListOfEventsComponent,
            resolve: {
              events: EventListResolver,
              organisers: OrganizersListReslover,
              ...generateCodebookResolvers('eventStatuses', 'languages')
            },
          },
          {
            path: 'events',
            children: [
              {
                path: 'add', component: AdminEventDetailsComponent, resolve: {
                  organisers: OrganizersListReslover,
                  measurers: MeasurersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: 1}
              },
              {
                path: 'edit',
                component: AdminEventDetailsComponent,
                resolve: {
                  eventItem: EventDetailsResolver, paymentSettings: EventPaymentSettingsResolver,
                  organisers: OrganizersListReslover,
                  measurers: MeasurersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: EventDetailsComponentType.EDIT}
              },
              {
                path: 'copy',
                component: AdminEventDetailsComponent,
                resolve: {
                  eventItem: CopyEventResolver, paymentSettings: EventPaymentSettingsResolver,
                  organisers: OrganizersListReslover,
                  measurers: MeasurersListReslover,
                  userRole: UserRoleResolver,
                  ...eventCodebookResolver
                },
                data: {type: EventDetailsComponentType.COPY}
              },
              {
                path: 'management',
                component: EventManagementComponent,
                resolve: {
                  waypointList: MeasurementsWaypointListResolver,
                  eventItem: EventDetailsResolver,
                  competitors: RaceCompetitorsPrivateResolver,
                  raceRegistrations: EventRegistrationsResolver,
                  raceCommercialItems: EventCommercialItemsPriceResolver,
                  raceAdditionalPricingItems: EventAdditionalPricingItemsResolver,
                  ...generateCodebookResolvers('languages', 'genders', 'countries')
                },
                data: {measurement: false}
              },
              {
                path: 'management',
                children: [
                  registerToRaceItem('registerToRace', false, true)]
              },
              {
                path: 'copy', children: [
                  {
                    path: 'race',
                    children: [
                      {
                        path: 'edit',
                        component: AdminRaceDetailsComponent,
                        resolve: {
                          raceData: CopyRaceResolver,
                          raceCommercialItems: RaceCommercialItemsResolver,
                          raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                          ...raceCodebookResolver
                        },
                        data: {type: RaceDetailsComponentType.EVENT_COPY}
                      },
                    ]
                  },
                ]
              },
              {
                path: 'race',
                children: [
                  {
                    path: 'add', component: AdminRaceDetailsComponent, resolve: {
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.ADD}

                  },
                  {
                    path: 'edit', component: AdminRaceDetailsComponent, resolve: {
                      race: RaceItemDetailsResolver,
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.EDIT}
                  },
                  {
                    path: 'copy', component: AdminRaceDetailsComponent, resolve: {
                      race: CopyRaceResolver,
                      event: EventDetailsResolver,
                      categories: EventCategoryResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      waypointList: WaypointListResolver,
                      raceRoute: RaceRouteResolver,
                      ...raceCodebookResolver
                    },
                    data: {componentType: RaceDetailsComponentType.RACE_COPY}
                  },
                  {
                    path: 'management', component: RaceManagementComponentComponent, resolve: {
                      waypointList: MeasurementsWaypointListResolver,
                      race: RaceItemDetailsResolver,
                      eventItem: EventDetailsResolver,
                      raceCommercialItems: RaceCommercialItemsResolver,
                      raceAdditionalItems: RaceAdditionalPricingItemsResolver,
                      competitors: RaceCompetitorsPrivateResolver,
                      results: CompetitorResultListResolver,
                      categories: CategoriesResolver,
                      ...registerToRaceCodebookResolver
                    },
                    data: {measurement: false}
                  },
                  {
                    path: 'management',
                    children: [
                      registerToRaceItem('registerToRace', false, true)]
                  },
                ]
              }
            ]
          },
          {
            path: 'preview', component: EventPreviewComponent, resolve: {
              eventDetailsHolder: EventDetailsHolderPublicResolver,
              ...eventCalendarCodebookResolver
            },
            data: {isPreview: true}
          },
          {
            path: 'preview', children: [
              eventDetailsItem('eventDetails'),
              {
                path: 'eventDetails',
                children: [
                  registerToRaceItem('registerToRace', true),
                  raceDetailsItem('raceDetails'),
                  {
                    path: 'raceDetails',
                    children: [
                      registerToRaceItem('registerToRace', true),
                    ]
                  }
                ]
              }
            ],
            data: {isPreview: true}
          },
          {
            path: 'requests',
            component: RequestsPageComponent,
            resolve: {
              userRole: UserRoleResolver,
            },
            children: [
            {
              path: 'incoming',
              component: ListOfRequestsComponent,
              resolve: {
                requests: OrganizersRequestListResolver,
                userRole: UserRoleResolver,
                ...generateCodebookResolvers('requestStatuses', 'requestTypes', 'languages', 'countries')
              },
              data: { type: ListOfRequestsType.INCOMING }
            },
          {
            path: 'outgoing',
            component: ListOfRequestsComponent,
            resolve: {
              requests: OrganizersRequestListResolver,
              userRole: UserRoleResolver,
              ...generateCodebookResolvers('requestStatuses', 'requestTypes', 'languages', 'countries')
            },
            data: { type: ListOfRequestsType.OUTGOING }
          },
          { path: '', redirectTo: 'incoming', pathMatch: 'full' }
          ],
            data: {feature: Features.RequestsList, permission: Permission.Edit}
          },
          {
            path: 'administrators',
            component: ListOfAdministratorsComponent,
            resolve: {administrators: AdministratorsResolver},
            data: {feature: Features.Administrators, permission: Permission.Edit}
          },
          {
            path: 'administrators', children: [
              {
                path: 'details',
                component: OrganiserAdminDetailsComponent,
                resolve: {administrator: AdministratorDetailsResolver, allOrganisers: OrganizersListReslover},
                data: {feature: Features.Administrators, permission: Permission.Edit}
              },
            ]
          },
          {
            path: 'accountStatements',
            component: ListOfAccountStatementsComponent,
            resolve: {accountStatements: AccountStatementsReslover},
            data: {feature: Features.AccountStatements, permission: Permission.Edit}
          },
          {
            path: 'accountStatements',
            children: [
              {
                path: 'details',
                component: AccountStatementDetailsComponent,
                resolve: {
                  accountStatements: AccountStatementsReslover,
                  accountStatementItemList: AccountStatementItemListReslover,
                  ...generateCodebookResolvers('languages')
                },
                data: {feature: Features.AccountStatementsDetails, permission: Permission.Edit}
              },
            ]
          },
          {
            path: 'leagues',
            component: ListOfLeaguesComponent,
            resolve: {
              leagues: LeaguesResolver,
              ...generateCodebookResolvers('languages', 'leagueOrganisers', 'leaguesStatuses', 'visibilityStatuses'),
              userRole: UserRoleResolver,
            },
            data: {feature: Features.LeaguesList, permission: Permission.Edit}
          },
          {
            path: 'leagues',
            children: [
              {
                path: 'edit',
                component: AdminLeagueDetailsComponent,
                resolve: {
                  league: LeagueResolver,
                  leagueEvents: LeagueEventsResolver,
                  userRole: UserRoleResolver,
                  organisers: OrganizersListReslover,
                  ...generateCodebookResolvers('languages', 'sports', 'measurementPrecisionTypes',
                      'countries', 'rankingMethods', 'scoringMethods', 'attendanceBonusTypes', 'groupScoringTypes')
                },
                data: {feature: Features.LeagueDetails, permission: Permission.Edit, isAdmin: true}
              },
              {
                path: 'add', component: AdminLeagueDetailsComponent, resolve: {
                  organisers: OrganizersListReslover,
                  userRole: UserRoleResolver,
                  ...generateCodebookResolvers('languages', 'sports', 'measurementPrecisionTypes',
                      'countries', 'rankingMethods', 'scoringMethods', 'attendanceBonusTypes', 'groupScoringTypes')
                },
                data: {type: LeagueDetailsComponentType.ADD}
              },
              {
                path: 'management',
                component: LeagueManagementComponent,
                resolve: {
                  init: LeagueManagementInitResolver,
                },
                children: [
                  { path: '', redirectTo: 'events', pathMatch: 'full' },
                  {
                    path: 'events',
                    component: LeagueEventsComponent,
                    resolve: {
                      league: LeagueManagementLeagueResolver,
                      leagueEvents: LeagueManagementEventsResolver,
                      ...generateCodebookResolvers('countries', 'languages')
                    },
                  },
                  {
                    path: 'competitors',
                    component: LeagueCompetitorsComponent,
                    resolve: {
                      competitors: LeagueCompetitorsResolver,
                      league: LeagueManagementLeagueResolver,
                      leagueEvents: LeagueManagementEventsResolver,
                      categoryItems: LeagueCompetitorsCategoryItemsResolver,
                      competitorsCountries: LeagueCompetitorsCountriesResolver,
                      duplicates: LeagueDuplicateCompetitorsCandidateResolver,
                      ...generateCodebookResolvers('countries', 'languages')
                    },
                    data: {
                      isAdmin: true
                    }
                  },
                  {
                    path: 'results',
                    component: LeagueResultsManagementComponent,
                    children: [
                      { path: '', redirectTo: 'by-round', pathMatch: 'full' },
                      {
                        path: 'by-round',
                        component: LeagueRoundResultsComponent,
                        resolve: {
                          league: LeagueManagementLeagueResolver,
                          categoryItems: LeagueCompetitorsCategoryItemsResolver,
                          availableRaces: LeagueResultsAvailableRacesResolver,
                          ...generateCodebookResolvers('genders'),
                        }
                      },
                      {
                        path: 'overall',
                        component: LeagueOverallResultsComponent,
                        resolve: {
                          league: LeagueManagementLeagueResolver,
                          standingsMeta: LeagueStandingsMetaResolver,
                          categoryItems: LeagueCompetitorsCategoryItemsResolver,
                          competitorsCountries: LeagueCompetitorsCountriesResolver,
                          ...generateCodebookResolvers('genders'),
                        },
                        data: {isAdmin: true}
                      },
                    ],
                  },
                ]
              },
            ]
          },
          {
            path: 'users',
            component: ListOfUsersComponent,
            resolve: {users: UserListResolver},
            data: {feature: Features.Users, permission: Permission.Edit}
          },
          {
            path: 'users', children: [
              {
                path: 'details', component: UserDetailsComponent,
                resolve: {
                  user: UserResolver,
                  ...userProfileCodebookResolver
                },
                data: {feature: Features.Users, permission: Permission.Edit}
              },
            ]
          },
          {
            path: 'organisers',
            component: ListOfOrganisersComponent,
            resolve: {organisers: OrganizersListReslover},
            data: {feature: Features.OrganisersList, permission: Permission.Edit}
          },
          {
            path: 'measurements',
            component: ListOfEventsComponent,
            resolve: {
              events: EventListResolver,
              organisers: OrganizersListReslover,
              ...generateCodebookResolvers('eventStatuses', 'languages')
            },
            data: {from: 'measurements'},
          },
          {
            path: 'measurements',
            children: [
              {
                path: 'management',
                component: EventMeasurementsManagementComponent,
                resolve: {
                  waypointList: MeasurementsWaypointListResolver,
                  eventItem: MeasurementEventDetailsResolver,
                  competitors: RaceCompetitorsPrivateResolver,
                  raceRegistrations: EventRegistrationsResolver,
                  ...generateCodebookResolvers('languages','genders', 'countries')
                },
                data: {measurement: true}
              },
            ]
          },
          {
            path: 'organisers', children: [
              {
                path: 'edit',
                component: OrganiserDetailsComponent,
                data: {feature: Features.OrganisersEdit, permission: Permission.Edit},
                resolve: {
                  users: UserListResolver,
                  paymentData: OrganiserPaymentDataResolver,
                  listOfDiscounts: ListOfDiscountsResolver,
                  categories: CategoryResolver,
                  ...organiserCodebookResolver,
                }
              },
              {
                path: 'edit', children: [{
                  path: 'discountDetails',
                  component: DiscountsDetailsComponent,
                  resolve: {discount: DiscountsDetailsResolver}
                }
                ]
              },
              {
                path: 'add',
                component: OrganiserDetailsComponent,
                data: {feature: Features.OrganisersAdd, permission: Permission.Edit}, resolve: {
                  ...organiserCodebookResolver
                }
              },
            ]
          },
          {
            path: 'messages',
            component: MessagesComponent,
            resolve: {
              messages: MessageResolver,
            },
            data: {
              isAdmin: true
            }
          }
        ], canActivate: [canActivateAdminGuard()], canActivateChild: [canActivateChildAdminGuard()]
      },
      ...liveResults(),
      {
            path: 'myTracey',
            resolve: {
              init: MyTraceyInitResolver,
              currentUserDetails: CurrentUserDetailsResolver,
              ...generateCodebookResolvers('countries')
            },
            component: MyTraceyComponent,
            children: [
              { path: '', redirectTo: 'overview', pathMatch: 'full' },
              {
                path: 'overview',
                component: MyTraceyOverviewComponent,
                canActivate: [canActivateMyTraceyProfileGuard()],
                resolve: {
                  upcomingEvents: UserUpcomingResolver,
                  favoriteEvents: UserFavoritesResolver,
                  recommendedEvents: UserRecommendedResolver,
                  pastEvents: UserResultsResolver,
                  currentUserDetails: CurrentUserDetailsResolver,
                  userStatistics: UserStatisticResolver
                },
                data: {
                  activeTab: MyTraceyTabs.OVERVIEW,
                  state: MyTraceyComponentState.TABS,
                }
              },
              {
                path: 'upcoming',
                component: MyTraceyUpcomingComponent,
                canActivate: [canActivateMyTraceyProfileGuard()],
                resolve: {
                  upcomingEvents: UserUpcomingResolver,
                  pastEvents: UserResultsResolver,
                  sports: UserEventsSportsResolver,
                  countries: UserEventsCountriesResolver
                },
                data: {
                  activeTab: MyTraceyTabs.UPCOMING,
                  state: MyTraceyComponentState.TABS,
                }
              },
              {
                path: 'favorites',
                component: MyTraceyFavoritesComponent,
                canActivate: [canActivateMyTraceyProfileGuard()],
                resolve: {
                  favoriteEvents: UserFavoritesResolver,
                  sports: UserEventsSportsResolver,
                  countries: UserEventsCountriesResolver
                },
                data: {
                  activeTab: MyTraceyTabs.FAVORITES,
                  state: MyTraceyComponentState.TABS,
                }
              },
              {
                path: 'results',
                component: MyTraceyResultsComponent,
                canActivate: [canActivateMyTraceyProfileGuard()],
                resolve: {
                  pastEvents: UserResultsResolver,
                  sports: UserEventsSportsResolver,
                  countries: UserEventsCountriesResolver},
                data: {
                  activeTab: MyTraceyTabs.RESULTS,
                  state: MyTraceyComponentState.TABS,
                }
              },
              // {
              //   path: 'orders',
              //   component: MyTraceyOrdersComponent,
              //   canActivate: [canActivateMyTraceyProfileGuard()],
              //   resolve: {
              //     registrations: UserRegistrationsResolver,
              //     ...generateCodebookResolvers('countries', 'languages')
              //   }
              // },
              {
                path: 'edit',
                component: UserProfileEditComponent,
                resolve: {
                  currentUserDetails: CurrentUserDetailsResolver,
                  ...userProfileCodebookResolver
                },
                data: {
                  state: MyTraceyComponentState.EDIT,
                }
              },
              {
                path: 'entry',
                resolve: {
                  userEvent: MyEntryDetailsResolver,
                  ...generateCodebookResolvers('countries', 'languages', 'genders')
                },
                data: { state: MyTraceyComponentState.MY_ENTRY,
                  hideTemplateMobile: true
                },
                children: [
                  {
                    path: '',
                    component: MyEntryComponent
                  },
                  // {
                  //   path: 'payment',
                  //   component: MyEntryCompletePaymentComponent,
                  //   resolve: {
                  //     registration: MyOrderDetailsResolver,
                  //   },
                  // },
                  {
                    path: 'personalInfo',
                    component: MyEntryPersonalInfoComponent,
                    data: { state: MyTraceyComponentState.PERSONAL_INFO },
                  },
                ],
              },
              {
                path: 'order',
                resolve: {
                  registration: MyOrderDetailsResolver,
                  ...generateCodebookResolvers('countries', 'languages', 'genders')
                },
                data: { state: MyTraceyComponentState.MY_ORDER,
                },
                children: [
                  {
                    path: '',
                    component: MyTraceyOrderDetailsComponent
                  },
                  {
                    path: 'payment',
                    component: MyEntryCompletePaymentComponent,
                  },
                ],
              },
            ]
      },
      {
        path: 'messages',
        component: MessagesComponent,
        resolve: {
          messages: MessageResolver
        },
        data: {isAdmin: false}
      },
      ...commonMenuItems()
    ], canActivate: [canActivateAuthenticationGuard()]
  },
  {
    path: 'landing',
    component: LandingComponent,
    resolve: {
      upcomingItems: UpcomingEventsResolver,
      newItems: NewEventsResolver,
      ...generateCodebookResolvers('countries', 'languages')
    }
  },
  {
    path: 'test',
    component: TestComponent,
    resolve: {
      upcomingItems: UpcomingEventsResolver
    }
  },
  {
    path: 'landing',
    children: [
      eventDetailsItem('eventDetails'),
      raceDetailsItem('raceDetails'),
      {
        path: 'eventDetails',
        children: [
          raceDetailsItem('raceDetails'),
          registerToRaceItem('registerToRace'),
          {
            path: 'raceDetails',
            children: [
              registerToRaceItem('registerToRace'),
            ]
          },
        ]
      },
      eventDetailsItem('eventDetails/:slug'),
      {
        path: 'eventDetails/:slug',
        children: [
          raceDetailsItem('raceDetails'),
          registerToRaceItem('registerToRace'),
          {
            path: 'raceDetails',
            children: [
              registerToRaceItem('registerToRace'),
            ]
          },
        ]
      },
    ]
  },
  ...commonMenuItems(),
  {path: '**', redirectTo: '/landing'}
];

export default routes;
